import React, { useState } from "react";
import { Button, Form } from "react-bootstrap";
import axios from "axios";
import { Rating } from "react-simple-star-rating";
import "./ReviewInput.scss";

const { REACT_APP_API_ENDPOINT } = process.env;
export default function ReviewInput(props) {
  const handleRating = (rate) => {
    setRating(rate);
  };
  const [rating, setRating] = useState(0);
  const [inputs, setInputs] = useState({
    name: "",
    text: "",
  });

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setInputs((values) => ({ ...values, [name]: value, rating: rating }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    axios
      .post(REACT_APP_API_ENDPOINT + "/" + props.data.id + "/review", inputs)
      .then((res) => {
        props.fetchData();
        setInputs({
          name: "",
          text: "",
        });
        setRating(0);
      })
      .catch((res) => {
        console.log(res);
      });
  };

  return (
    <div className="review-input">
      <Form onSubmit={handleSubmit}>
        <Form.Group
          className="mb-3 review-input__field"
          action="post"
          method="post"
        >
          <Rating onClick={handleRating} ratingValue={rating} />
          <Form.Label htmlFor="review">
            <Form.Control
              type="text"
              name="text"
              className="review-input__control"
              placeholder="add a new review"
              autoComplete="off"
              id="review-text"
              onChange={(event) => handleChange(event)}
              value={inputs.text}
            />
          </Form.Label>
          <Form.Label htmlFor="review">
            <Form.Control
              type="text"
              autoComplete="off"
              name="name"
              className="review-input__control"
              placeholder="Your Name"
              id="input-name"
              value={inputs.name}
              onChange={(event) => handleChange(event)}
            />
          </Form.Label>

          <Button
            className="review-input__button"
            variant="primary"
            type="submit"
          >
            Submit
          </Button>
        </Form.Group>
      </Form>
    </div>
  );
}
